var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#0F8570"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.26 18.782c-1.68-1.686-1.68-4.432 0-6.118l3.386-3.4c1.68-1.685 4.415-1.685 6.094 0 1.68 1.686 1.68 4.433 0 6.119l-3.216 3.229c-.18.186-.448.26-.698.194-.25-.066-.446-.262-.512-.514-.066-.251.008-.519.194-.7l3.217-3.229c1.134-1.139 1.134-2.94 0-4.079-1.135-1.139-2.93-1.138-4.064 0l-3.386 3.4c-1.134 1.138-1.134 2.94 0 4.078.186.181.26.449.194.7-.066.252-.261.448-.512.514-.25.066-.517-.008-.697-.194zm-7 6.954c-1.68-1.686-1.68-4.433 0-6.119l3.216-3.229c.18-.186.448-.26.698-.195.25.066.447.263.512.514.066.252-.008.52-.194.701l-3.217 3.23c-1.134 1.138-1.134 2.94 0 4.078 1.135 1.139 2.93 1.139 4.064 0l3.386-3.4c1.134-1.138 1.134-2.94 0-4.078-.186-.181-.26-.449-.194-.7.066-.252.261-.448.512-.514.25-.066.517.008.697.194 1.68 1.686 1.68 4.433 0 6.119l-3.386 3.398c-1.68 1.687-4.415 1.687-6.094 0z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainHover);
export default __webpack_public_path__ + "static/media/chain_hover.c27007245feb49a564c5bccbadfbb00f.svg";
export { ForwardRef as ReactComponent };